import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Copy, ZoomIn, ZoomOut } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { API } from "@/lib/api";
import { imgVersion } from "@/lib/format";

export default function BoletoModal({ meta, open, onClose }) {
  const [zoom, setZoom] = useState(false);
  if (!meta) return null;

  const copyPix = async () => {
    try {
      await navigator.clipboard.writeText(meta.chave_pix);
      toast.success("Chave Pix copiada!");
    } catch (e) {
      toast.error("Não foi possível copiar. Selecione e copie manualmente.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="boleto-modal" className="max-w-3xl max-h-[94vh] overflow-y-auto rounded-2xl p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl sm:text-2xl font-bold text-slate-900 pr-10">
            {meta.referente} — Guia de Contribuição
          </DialogTitle>
          <DialogDescription className="text-base text-slate-600">
            Documento visual de contribuição via Pix. Escaneie o QR Code ou copie a chave Pix.
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-center bg-slate-50 rounded-xl border border-slate-200 p-3">
          <img
            data-testid="boleto-image"
            src={`${API}/metas/${meta.id}/boleto.png${imgVersion(meta)}`}
            alt={`Guia de contribuição — ${meta.referente}`}
            className={zoom ? "w-full rounded-lg" : "max-h-[55vh] w-auto rounded-lg shadow-md"}
          />
        </div>

        <div className="flex flex-wrap gap-2 justify-center mt-3">
          <button
            type="button"
            data-testid="boleto-zoom-button"
            onClick={() => setZoom(!zoom)}
            className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-base border border-slate-200 transition-colors"
          >
            {zoom ? <ZoomOut className="w-5 h-5" /> : <ZoomIn className="w-5 h-5" />}
            {zoom ? "Reduzir" : "Ampliar"}
          </button>
          {meta.chave_pix && (
            <button
              type="button"
              data-testid="boleto-copy-pix-button"
              onClick={copyPix}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-blue-800 hover:bg-blue-700 text-white font-bold text-base transition-colors"
            >
              <Copy className="w-5 h-5" /> Copiar Chave Pix
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
